import helpers from '../helpers';

const $popup = document.querySelector('.popup');
const $popupText = document.querySelector('.popup__text');
const $popupClose = document.querySelector('.js-popup-close');
const $popupScroll = $('.popup__wrapper');

const openPopup = (text) => {
	if (text) {
		$popupText.innerHTML = text;
	}

	$popup.classList.add('is-active');
	helpers.lockScroll(true, $popupScroll, 'popup');
};

const closePopup = () => {
	helpers.lockScroll(false, $popupScroll, 'popup');
	$popup.classList.add('is-hide');

	setTimeout(() => {
		$popup.classList.remove('is-active');
		$popup.classList.remove('is-hide');
	}, 1000);
};

const init = () => {
	$popupClose.addEventListener('click', () => {
		closePopup();
	});
	document.querySelector('.popup__bg').addEventListener('click', () => {
		closePopup();
	});
};

export default {
	init,
	openPopup,
	closePopup,
};
